module.exports = __webpack_public_path__ + "img/broward-medical-examiners-sheriff-facility-2.8f91ff63.jpg";